
import React from 'react';
import { FEATURES, COLORS } from '../constants';

const FeaturesGrid: React.FC = () => {
  return (
    <section id="features" className="pb-16 md:pb-20 pt-12 md:pt-16 bg-[#F8FAFA]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-20 text-center mb-8 md:mb-12 reveal-item">
        <h2 className="fluid-heading-lg font-bold leading-tight mb-4 text-[#1E1E1E]">
          We offer quality, <span className="text-gray-400 font-medium">with the</span> <br />
          <span className="text-gray-400 font-medium italic">best materials and service</span>
        </h2>
      </div>

      <div className="max-w-[1240px] mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 bg-white border border-gray-100 rounded-[0.4rem] md:rounded-[0.8rem] overflow-hidden shadow-sm">
          {FEATURES.map((feature, idx) => (
            <div 
              key={feature.id} 
              className={`p-8 md:p-14 group transition-colors duration-500 hover:bg-gray-50/50 relative reveal-item
                ${idx % 3 !== 2 ? 'lg:border-r lg:border-gray-100' : ''} 
                ${idx < 3 ? 'lg:border-b lg:border-gray-100' : ''}
                ${idx % 2 !== 1 ? 'md:border-r md:border-gray-100' : ''}
                ${idx < 4 ? 'md:border-b md:border-gray-100' : ''}
              `}
              style={{ transitionDelay: `${0.05 * idx}s` }}
            >
              <div 
                className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center mb-6 md:mb-8 shadow-sm transition-all duration-500 group-hover:scale-110 group-hover:rotate-3 group-hover:shadow-lg group-hover:shadow-emerald-500/20"
                style={{ backgroundColor: COLORS.novusGreen }}
              >
                <div className="text-white w-5 h-5 md:w-6 md:h-6">
                   {feature.icon}
                </div>
              </div>
              
              <h3 className="text-lg md:text-2xl font-bold mb-3 md:mb-4 text-[#1E1E1E] leading-tight">
                {feature.title}
              </h3>
              
              <p className="text-slate-500 leading-relaxed text-xs md:text-base font-medium opacity-80 group-hover:opacity-100 transition-opacity">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;
